import Vue from "vue";

let defaultUser = {
  id: false,
  email: '',
  first_name: '',
  last_name:'',
  is_superuser: false,
  is_staff: false,
  is_abit: false,
  is_email_activated: false,
}

export default {
  namespaced: true,
  state: {
    user: defaultUser,
    is_authenticated: false,
    is_initialized: false
  },
  getters: {
    is_authenticated: (state) => state.is_authenticated,
    user: (state) => state.user,
  },
  mutations: {
    SET_USER: (state, payload) => {
      Object.keys(payload).map(function (key) {
        if (key in state.user) {
          state.user[key] = payload[key]
        }
      });
    },
    DELETE_USER: (state) => {
      state.user = defaultUser
    },
    SET_AUTHENTICATED: (state) => {
      state.is_authenticated = true
    },
    RESET_AUTHENTICATED: (state) => {
      state.is_authenticated = false
    },
    SET_INITIALIZED: (state) => {
      state.is_initialized = true
    },
    RESET_INITIALIZED: (state) => {
      state.is_initialized = false
    }
  },
  actions: {
    async authStatus({state, commit}) {
      if (!state.is_initialized) {
        commit('SET_INITIALIZED');
        await Vue.axios.post('account/auth_status/')
          .then((response) => {
            if (response.status === 200) {
              commit('SET_AUTHENTICATED');
              commit('SET_USER', response.data);
            }
          })
          .catch(() => {
            commit('RESET_INITIALIZED');
            commit('RESET_AUTHENTICATED');
            commit('DELETE_USER');
          })
      }
    },

    async login({commit, dispatch}, payload) {
      commit('context/ENABLE_LOADING', null, {root: true})

      await Vue.axios.post('account/login/', payload)
        .then(() => {
          commit('SET_AUTHENTICATED');
          commit('RESET_INITIALIZED');
          commit('context/DISABLE_LOADING', null, {root: true})
        })
        .catch((error) => {
          commit('RESET_AUTHENTICATED');
          commit('RESET_INITIALIZED');
          commit('context/DISABLE_LOADING', null, {root: true})
          dispatch('django/handleError', {error}, {root: true})
        })
    },

    async registration({commit, dispatch}, payload) {
      commit('context/ENABLE_LOADING', null, {root: true})

      await Vue.axios.post('account/registration/', payload)
        .then(() => {
          commit('RESET_INITIALIZED');
          // dispatch("authStatus")
          // dispatch("abiturient/loadAbiturient", null, {root: true})
          commit('context/DISABLE_LOADING', null, {root: true})
        })
        .catch((error) => {
          commit('context/DISABLE_LOADING', null, {root: true})
          dispatch('django/handleError', {error}, {root: true})
          if (error.response.status === 400 && error.response.data.non_field_errors) {
            commit('context/SET_MESSAGES', {
              'detail': error.response.data.non_field_errors,
            }, {root: true})
          }
        })
    },

    async registration_activation({commit, dispatch}, payload) {
      await Vue.axios.post('account/registration_activation/', payload)
        .then(() => {
          commit('RESET_INITIALIZED');
          dispatch("authStatus")
        })
        .catch((error) => {
          dispatch('django/handleError', {error}, {root: true})
        })
    },

    async send_email_activation({dispatch}) {
      await Vue.axios.post('account/send_email_activation/')
        .catch((error) => {
          dispatch('django/handleError', {error}, {root: true})
        })
    },

    async send_email_promotion({dispatch}) {
      await Vue.axios.post('account/send_email_promotion/')
        .catch((error) => {
          dispatch('django/handleError', {error}, {root: true})
        })
    },

    async password_recovery({commit, dispatch}, payload) {
      commit('context/ENABLE_LOADING', null, {root: true})

      await Vue.axios.post('account/password_recovery/', payload)
        .then(() => {
          commit('context/DISABLE_LOADING', null, {root: true})
        })
        .catch((error) => {
          commit('context/DISABLE_LOADING', null, {root: true})
          dispatch('django/handleError', {error}, {root: true})
        })
    },

    async password_reset({commit, dispatch}, payload) {
      await Vue.axios.post('account/password_reset/', payload)
        .catch((error) => {
          dispatch('django/handleError', {error}, {root: true})
          if (error.response.status === 400 && error.response.data.non_field_errors) {
            commit('context/SET_MESSAGES', {
              'new_password1': error.response.data.non_field_errors,
              'new_password2': ' '
            }, {root: true})
          }
        })
    },

    async password_change({commit, dispatch}, payload) {
      await Vue.axios.post('account/password_change/', payload)
        .then(() => {
          commit('context/DISABLE_LOADING', null, {root: true})
        })
        .catch((error) => {
          commit('context/DISABLE_LOADING', null, {root: true})
          if (error.response.status === 400 && error.response.data.non_field_errors) {
            commit('context/SET_MESSAGES', {
              'new_password1': error.response.data.non_field_errors,
              'new_password2': ' '
            }, {root: true})
          }
          dispatch('django/handleError', {error}, {root: true})
        })
    },

    async logout({commit}) {
      await Vue.axios.get('account/logout/');
      commit('RESET_INITIALIZED')
      commit('RESET_AUTHENTICATED')
      commit('DELETE_USER')
    },
  }
}
